import * as React from "react";
const SvgArrayDropDownH = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15, height: 7.5, viewBox: "0 0 15 7.5", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Icon_material-sharp-arrow-drop-down", "data-name": "Icon material-sharp-arrow-drop-down", d: "M10.5,15,18,22.5,25.5,15Z", transform: "translate(-10.5 -15)" }));
export { SvgArrayDropDownH as ReactComponent };

export { default } from "./array-drop-down-h.svg?url"
